import { render } from "./VerticalScroll.vue?vue&type=template&id=38524b46"
import script from "./VerticalScroll.vue?vue&type=script&lang=js"
export * from "./VerticalScroll.vue?vue&type=script&lang=js"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__